import React from 'react'
import { Box, Text } from '@primer/react'

interface IWarningCheckInHocSinhProps {
    data: any
    isInvalid?: boolean
}

const WarningCheckInHocSinh = ({ data, isInvalid }: IWarningCheckInHocSinhProps) => {
    return (
        <Box
            sx={{
                p: 3,
                borderRadius: 12,
                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                textAlign: 'center',
                bg: 'canvas.default',
                border: isInvalid ? '1px solid #dc3545' : '1px solid #e1e4e8',
            }}
        >
            {/* Ảnh học sinh */}
            <Box
                as="img"
                src={data.image_url}
                alt={data.ho_ten}
                sx={{
                    width: '100%',
                    height: 180,
                    borderRadius: 8,
                    objectFit: 'cover',
                    mb: 2,
                }}
            />

            {/* Họ tên */}
            <Text
                as="div"
                sx={{
                    fontWeight: 700,
                    fontSize: 16,
                    color: isInvalid ? '#dc3545' : 'fg.default',
                }}
            >
                {data.ho_ten}
            </Text>

            {/* Mã HS */}
            <Text as="div" sx={{ color: 'fg.muted', fontSize: 13, mb: 1 }}>
                {data.ma_hs}
            </Text>

            {/* Lớp */}
            <Text as="div" sx={{ fontSize: 14, mb: 2 }}>
                {data.ten_lop}
            </Text>

            {/* Trạng thái */}
            {data.gio_diem_danh &&
                <Text
                    sx={{
                        color: 'danger.fg',
                        fontWeight: 600,
                        fontSize: 13,
                    }}
                >
                    Giờ điểm danh: {data.gio_diem_danh}
                </Text>
            }
        </Box>
    )
}

export default WarningCheckInHocSinh
